export type AIModel = 'gemini' | 'grok' | 'open';

export class ModelToView {
  public static toView(model: AIModel): { name: string; version: string } {
    switch (model) {
      case 'gemini': {
        return {
          name: 'Gemini',
          version: 'gemini-3-pro',
        };
      }

      case 'grok': {
        return {
          name: 'Grok',
          version: 'grok-4-fast-reasoning',
        };
      }

      case 'open': {
        return {
          name: 'OpenAI',
          version: 'gpt-5.1',
        };
      }

      default: {
        const _: never = model;

        return {
          name: model,
          version: model,
        };
      }
    }
  }
}
